var React = require('react');

function PlusIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.588 6.522H0.606V5.136H4.588V0.977999H6.15V5.136H10.154V6.522H6.15V10.68H4.588V6.522Z","fill":"white"}));
}

PlusIcon.defaultProps = {"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none"};

module.exports = PlusIcon;

PlusIcon.default = PlusIcon;
